import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/my_company_members/UserEmploymentTerms.scss';
import * as _ from 'lodash';
import { withRouter } from 'react-router';
import autobind from 'autobind-decorator';
import UserEmploymentTermsForm from '../../forms/my_company_members/UserEmploymentTermsForm';
import { __, mapStateToProps, validateForm } from '../../core/utils';
import { setNotification } from '../../redux/actions/general/notification';
import { updateCompanyMemberDetails } from '../../redux/actions/table/my_company_members';
import {
  convertMinutesToHours,
  convertMinutesToCompensatoryDays,
  convertHoursToMinutes,
  convertCompensatoryDaysToMinutes,
} from '../../core/utils';
import classNames from 'classnames';
import moment from 'moment';

// {table, data, collapsed, readAction}

@withRouter
@mapStateToProps((state) => ({
  table: state.table['my_company_members'],
}))
class UserEmploymentTerms extends Component {
  @autobind
  extractWorkExperience(str) {
    if (!str) return { years: 0, months: 0, days: 0 };

    const yearPattern = new RegExp(`(\\d+)${__('year')}`);
    const monthPattern = new RegExp(`(\\d+)(?:${__('month')}|m)`);
    const dayPattern = new RegExp(`(\\d+)(?:${__('day')}|d)`);

    const yearsMatch = str.match(yearPattern);
    const monthsMatch = str.match(monthPattern);
    const daysMatch = str.match(dayPattern);

    return {
      years: yearsMatch ? parseInt(yearsMatch[1], 10) : 0,
      months: monthsMatch ? parseInt(monthsMatch[1], 10) : 0,
      days: daysMatch ? parseInt(daysMatch[1], 10) : 0,
    };
  }

  @autobind
  _handleSubmit(formData) {
    const {
      flyout: { details },
    } = this.props.table;

    const prior_work_experience = formData?.prior_work_experience;

    // Ako postoji npr vrijednost "12-11-05"
    let prior_work_experience_years = 0;
    let prior_work_experience_months = 0;
    let prior_work_experience_days = 0;

    if (prior_work_experience) {
      const parts = prior_work_experience
        .split('-')
        .map((x) => parseInt(x, 10) || 0);
      prior_work_experience_years = parts[0] || 0;
      prior_work_experience_months = parts[1] || 0;
      prior_work_experience_days = parts[2] || 0;
    }

    formData = {
      ...formData,

      logs_time: formData?.logs_time === 'true' ? true : false,

      user_id: details?.id,
      firstname: details?.firstname,
      lastname: details?.lastname,

      prior_work_experience_years,
      prior_work_experience_months,
      prior_work_experience_days,

      monday_minutes: convertHoursToMinutes(formData?.monday_minutes),
      tuesday_minutes: convertHoursToMinutes(formData?.tuesday_minutes),
      wednesday_minutes: convertHoursToMinutes(formData?.wednesday_minutes),
      thursday_minutes: convertHoursToMinutes(formData?.thursday_minutes),
      friday_minutes: convertHoursToMinutes(formData?.friday_minutes),
      saturday_minutes: convertHoursToMinutes(formData?.saturday_minutes),
      sunday_minutes: convertHoursToMinutes(formData?.sunday_minutes),
      minutes_off_base: convertCompensatoryDaysToMinutes(
        formData?.minutes_off_base
      ),
      used_minutes_off: convertCompensatoryDaysToMinutes(
        formData?.used_minutes_off
      ),
      company_employment_date: formData?.company_employment_date
        ? moment(formData.date_of_birth, 'DD.MM.YYYY').format('YYYY-MM-DD')
        : null,
    };

    return validateForm(
      updateCompanyMemberDetails(formData).then(() => {
        this.props.readAction();

        setNotification(__('my-company-members.properties.saved'));
      })
    );
  }

  render() {
    const { data, collapsed } = this.props;

    return (
      <div
        className={classNames(styles.wrapper, collapsed && styles.collapsed)}
      >
        <UserEmploymentTermsForm
          onSubmit={this._handleSubmit}
          data={data}
          initialValues={{
            address_book_company_id:
              data?.employment_terms?.general?.address_book_company_id,
            company_segment_name:
              data.employment_terms?.general?.company_segment_name,
            work_place: data.employment_terms?.general?.work_place,
            company_position_id:
              data.employment_terms?.general?.company_position_id,
            type: data.employment_terms?.general?.type,
            logs_time: String(data.employment_terms?.general?.logs_time),
            // prior_work_experience: `${data.employment_terms?.prior_work_experience_years} ${data.employment_terms?.prior_work_experience_months} ${data.employment_terms?.prior_work_experience_days}`,
            prior_work_experience: `${data.employment_terms?.general?.prior_work_experience_years} ${data.employment_terms?.general?.prior_work_experience_months} ${data.employment_terms?.general?.prior_work_experience_days}`,
            // company_employment_date:
            //  data.employment_terms?.general?.company_employment_date,
            company_employment_date: data.employment_terms?.general
              ?.company_employment_date
              ? moment(
                  data.employment_terms?.general?.company_employment_date
                ).format('DD.MM.YYYY')
              : null,
            company_work_experience:
              data.employment_terms?.general?.company_work_experience,
            total_work_experience:
              data.employment_terms?.general?.total_work_experience,

            monday_minutes: convertMinutesToHours(
              data.employment_terms?.hours?.monday_minutes
            ),
            tuesday_minutes: convertMinutesToHours(
              data.employment_terms?.hours?.tuesday_minutes
            ),
            wednesday_minutes: convertMinutesToHours(
              data.employment_terms?.hours?.wednesday_minutes
            ),
            thursday_minutes: convertMinutesToHours(
              data.employment_terms?.hours?.thursday_minutes
            ),
            friday_minutes: convertMinutesToHours(
              data.employment_terms?.hours?.friday_minutes
            ),
            saturday_minutes: convertMinutesToHours(
              data.employment_terms?.hours?.saturday_minutes
            ),
            sunday_minutes: convertMinutesToHours(
              data.employment_terms?.hours?.sunday_minutes
            ),
            weekly_hours: data.employment_terms?.hours?.weekly_hours,

            vacation_days_base:
              data.employment_terms?.time_off?.vacation_days_base,
            minutes_off_base: convertMinutesToCompensatoryDays(
              data.employment_terms?.time_off?.minutes_off_base
            ),
            last_year_vacation_days:
              data.employment_terms?.time_off?.last_year_vacation_days,
            used_vacation_days:
              data.employment_terms?.time_off?.used_vacation_days,
            used_minutes_off: convertMinutesToCompensatoryDays(
              data.employment_terms?.time_off?.used_minutes_off
            ),
            vacation_days_remaining:
              data.employment_terms?.time_off?.vacation_days_remaining,
            available_compensatory_hours: convertMinutesToHours(
              data.employment_terms?.time_off?.available_compensatory_minutes
            ),
            working_days: data.employment_terms?.time_off?.working_days,
            sick_days: data.employment_terms?.time_off?.sick_days,
            working_hours: data.employment_terms?.time_off?.working_hours,
            overtime_hours: data.employment_terms?.time_off?.overtime_hours,

            user_id: data.details?.id,

            status: data.employment_terms?.status,
            created_at: data.employment_terms?.created_at,
            updated_at: data.employment_terms?.updated_at,

            general_changed_fields:
              data?.employment_terms?.general?.general_changed_fields,
            days_changed_fields:
              data?.employment_terms?.hours?.hours_changed_fields,
            time_off_changed_fields:
              data?.employment_terms?.time_off?.time_off_changed_fields,
            general_future: data?.employment_terms?.general?.general_future,
            days_future: data?.employment_terms?.hours?.hours_future,
            time_off_future: data?.employment_terms?.time_off?.time_off_future,
          }}
        />
      </div>
    );
  }
}

export default UserEmploymentTerms;
